import {
  INIT,
  LOAD,
  ERROR,
} from './STATES';

const reducers = (state = {}, { type, ...action }) => {
  switch (type) {
    case INIT:
      return {
        ...state,
        [action._id]: INIT,
      };

    case LOAD: {
      return {
        ...state,
        [action._id]: LOAD,
      };
    }

    case ERROR:
      return {
        ...state,
        [action._id]: ERROR,
      };

    default:
      return state;
  }
};

export default reducers;



// WEBPACK FOOTER //
// ./src/components/stateful/ProfileIcon/reducers.js